module.exports = __webpack_public_path__ + "img/03_punch.e4e35d58.jpg";